import { DtoExt } from '@/classes/scenario/DtoExt';
import { EcoOM } from '@/dto/scenario/eco/EcoOM';

export class EcoOMExt extends DtoExt {
  public static fromDto(dto: EcoOM): EcoOMExt {
    return new EcoOMExt({
      pvCost: dto.pvCost,
      pvFixedCost: dto.pvFixedCost,
      generatorFixedCost: dto.generatorFixedCost,
      generatorVariableCost: dto.generatorVariableCost,
      batteryCost: dto.batteryCost
    } as EcoOMExt);
  }

  public pvCost: number | null = null;
  public pvFixedCost: number | null = null;
  public generatorFixedCost: number | null = null;
  public generatorVariableCost: number | null = null;
  public batteryCost: number | null = null;

  constructor(options?: Partial<EcoOMExt> | null) {
    super();
    if (options) {
      DtoExt.assignToThis(this, options);
    }
  }

  public toDto(): EcoOM {
    return new EcoOM({
      pvCost: this.pvCost,
      pvFixedCost: this.pvFixedCost,
      generatorFixedCost: this.generatorFixedCost,
      generatorVariableCost: this.generatorVariableCost,
      batteryCost: this.batteryCost
    });
  }
}
